import * as React from 'react';
import { Header } from '../header';
import { Sidedrawer } from '../side-drawer/side-drawer.component';
import * as classes from './layout.scss';
import { ToastContainer } from 'react-toastify';
import { history } from '..';
import * as smoothscroll from 'smoothscroll-polyfill';

interface LayoutState {
  showSidebar: boolean;
}

interface LayoutProperties {
  children: any;
}

smoothscroll.polyfill();

export class Layout extends React.Component<LayoutProperties, LayoutState> {
  state = {
    showSidebar: false
  };

  toggleSidebar = () => {
    this.setState(prevState => {
      return { showSidebar: !prevState.showSidebar };
    });
  };

  render() {
    history.listen((location, action) => {
      // scroll back to top on route change
      document.getElementsByTagName('main')[0].scrollTo(0, 0);
    });

    return (
      <div className={classes.layout}>
        <aside className={this.state.showSidebar ? [classes.sidebar, classes.visible].join(' ') : classes.sidebar}>
          <Sidedrawer toggleSidebar={this.toggleSidebar} />
        </aside>
        <header className={classes.header}>
          <Header isSidebarOpen={this.state.showSidebar} toggleSidebar={this.toggleSidebar} />
        </header>
        <main className={classes.content}>{this.props.children}</main>
        <ToastContainer autoClose={3000} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout.tsx